import { Dispatch, SetStateAction } from "react";
import { IPrimaryUser } from "services/api/api.types";
import {
  Subject as IPackageSubject,
  ISection,
  ISlot
} from "services/api/packages/packageDetails.types";
export interface ISlotSelectionProps {
  backgroundColor: IPackageSubject["meta"]["backgroundColour"];
  color: IPackageSubject["meta"]["textColour"];
  iconSrc?: IPackageSubject["meta"]["iconSmall"];
  text: IPackageSubject["name"];
}

export type ISubjectTagDataItem = {
  text: string;
  iconSrc: string;
  backgroundColor: string;
  color: string;
};

export type ISubjectTagData = Record<string, ISubjectTagDataItem>;

export type IUseSlotSelection = {
  fullName: string;
  step: number;
  stepLength: number;
  sectionsData: ISectionDatWithFlag[];
  isLoading: boolean;
  selectedSection: number;
  setSelectedSection: (arg: number) => void;
  handleClickSection: (arg: number) => void;
  progressRef: number;
  handleNextSection: () => void;
  handleSelectSlot: (courseId: string, slot: ISlot) => void;
  getOrderedSlots: (slotItems: ISlot[]) => ISlot[];
  getClashesSlot: (
    slot: ISlot,
    section: ISectionDatWithFlag
  ) => string | undefined;
  formatTime: (value: string) => string;
  modal: string;
  handleCloseModal: () => void;
  handleFinishModalConfirmation: () => void;
  isDisabledNextButton: () => boolean;
  filteredSections: ISectionDatWithFlag[];
  phoneNumber: string;
  primaryUser: IPrimaryUser;
  handleClickHelp: () => void;
  setModal: Dispatch<SetStateAction<string>>;
  handleSlotSelectionSkip: () => void;
};

export interface ISectionDatWithFlag extends ISection {
  selected_slot?: {
    slot: ISlot;
    formatted_schedule: string;
    is_optional: boolean;
  };
}

export interface ISlotCardProps {
  isSelected: boolean;
  isOptional: boolean;
  isClashes?: string;
  title: string;
  days: string;
  startTime: string;
  endTime: string;
  onSelectSlot: () => void;
}

export enum IModal {
  CONFIRMATION = "CONFIRMATION",
  SUCCESS = "SUCCESS",
  CALL_ME_BACK_CONFIRMATION = "CALL_ME_BACK_CONFIRMATION",
  CALL_ME_BACK = "CALL_ME_BACK"
}

export enum ISlotSelectionClosed {
  CROSS_BUTTON = "cross button",
  HARDWARE_BACK_BUTTON = "hardware back button"
}
export enum ISlotSelectionClosedPage {
  FIRST_PAGE = "First Slot Selection Page",
  INTERMEDIATE_PAGE = "Intermediate Slot Selection Page",
  SLOT_CONFIRMATION_PAGE = "Slot Confirmation Page"
}
